import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ExpansionContainer from './components/ExpansionContainer';
import SpeakerItem from './SpeakerItem';

const RootContainer = styled.div`
  overflow: hidden;
`;

const locale = 'en';

const MobileSpeakerList = ({ speakers }) => (
  <RootContainer>
    <ExpansionContainer collapseHeight={140}>
      {
        speakers.map(({
          avatar, bio, translations,
        }, index) => (
          <SpeakerItem
            key={index}
            name={translations[locale].name}
            company={translations[locale].company}
            title={translations[locale].title}
            avatar={avatar}
            bio={bio}
          />
        ))
      }
    </ExpansionContainer>
  </RootContainer>
);

MobileSpeakerList.propTypes = {
  speakers: PropTypes.arrayOf(PropTypes.shape()),
};

MobileSpeakerList.defaultProps = {
  speakers: [],
};

export default MobileSpeakerList;
